export const FULLY_SHOWN_PERCENTAGE = 0.95;
